import { ReportsApiClient } from '@fourthwall/services/dist/ReportsApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useAnalyticsReportQuery = createQueryHook(ReportsApiClient.getReport, {
  queryKey: ['analyticsReport'],
})
